import {
    VIEW_DOCUMENT_FETCH_DATA_STORE,
    VIEW_DOCUMENT_FETCH_DATA_STARTED,
    VIEW_DOCUMENT_FETCH_DATA_LOADED
} from '../actions/actionsNamesList';

const defaultState = {
    loading: false,
    data: {
        info: {}
    }
};

export default function documentViewData(state = defaultState, action) {
    switch (action.type) {
        case VIEW_DOCUMENT_FETCH_DATA_LOADED: {
            return {
                ...state,
                loading: false
            };
        }
        case VIEW_DOCUMENT_FETCH_DATA_STARTED: {
            return {
                ...state,
                loading: true
            };
        }
        case VIEW_DOCUMENT_FETCH_DATA_STORE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.data,
                    info: {
                        ...state.data.info,
                        ...action.data.info
                    }
                }
            };
        }
        default: {
            return state;
        }
    }
}
